import type { Address } from 'viem'
import type { BitcoinAddress } from './bitcoin'
import type { SolanaAddress } from './solana'
import { RelayExecutionStatus } from './types'

/**
 * Chain id that Relay uses to identify Bitcoin
 *
 * See https://docs.relay.link/references/sdk/adapters#how-can-i-use-an-adapter%3F
 */
export const RELAY_BITCOIN_CHAIN_ID_NUMBER = 8253038 // Why cannot Relay export this themselves... -.-
export const RELAY_BITCOIN_CHAIN_ID = `${RELAY_BITCOIN_CHAIN_ID_NUMBER}`

/**
 * Chain id that Relay uses to identify Solana
 *
 * See https://docs.relay.link/references/sdk/adapters#how-can-i-use-an-adapter%3F
 */
export const RELAY_SOLANA_CHAIN_ID_NUMBER = 792703809 // Why cannot Relay export this themselves... -.-
export const RELAY_SOLANA_CHAIN_ID = `${RELAY_SOLANA_CHAIN_ID_NUMBER}`

export const FUN_SOLANA_CHAIN_ID_NUMBER = 1151111081099710
export const FUN_HYPERCORE_CHAIN_ID_NUMBER = 1337

export const RELAY_LIGHTER_CHAIN_ID_NUMBER = 3586256
export const RELAY_LIGHTER_CHAIN_ID = `${RELAY_LIGHTER_CHAIN_ID_NUMBER}`

export const RELAY_TRON_CHAIN_ID_NUMBER = 728126428
export const RELAY_TRON_CHAIN_ID = `${RELAY_TRON_CHAIN_ID_NUMBER}` as const

/**
 * Fake address for a chain's native currency used by Funkit
 */
export const FUNKIT_NATIVE_TOKEN =
  '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' satisfies Address

/**
 * Fake address for a chain's native currency used by Relay
 */
export const RELAY_NATIVE_TOKEN =
  '0x0000000000000000000000000000000000000000' satisfies Address

/**
 * Fake address for Hypercore's native currency used by Relay. This is shorter than the default native token...
 */
export const RELAY_NATIVE_TOKEN_HYPERCORE =
  '0x00000000000000000000000000000000' satisfies Address

/**
 * Fake address for Solana's native currency used by Relay
 */
export const RELAY_NATIVE_TOKEN_SOLANA =
  '11111111111111111111111111111111' satisfies SolanaAddress

/**
 * Fake address for Bitcoin's native currency used by Relay
 */
export const RELAY_NATIVE_TOKEN_BITCOIN =
  'bc1qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqmql8k8' satisfies BitcoinAddress

/**
 * Fake address for Lighter's native currency used by Relay
 */
export const RELAY_LIGHTER_USDC_PERPS = '0'
export const RELAY_LIGHTER_USDC_SPOT = '3'
export const RELAY_LIGHTER_ETH_SPOT = '1'

export const RELAY_LIGHTER_FUN_ADDRESS_MAP = {
  '0x0000000000000000000000000000000000000000': RELAY_LIGHTER_USDC_PERPS,
  '0x0000000000000000000000000000000000000001': RELAY_LIGHTER_ETH_SPOT,
  '0x0000000000000000000000000000000000000003': RELAY_LIGHTER_USDC_SPOT,
}

/**
 * Wallet that receives the app fees collected by Relay
 * Prev: 0xb61562d83aEC43a050A06BED12Ac2bD8f9BFfd5E
 */
export const FUN_RELAY_REVENUE_WALLET =
  '0xdfd877679e95c1276c85801805b2c2ab8f4f4cf6' satisfies Address

/**
 * Referred field in Relay quote
 */
export const FUN_RELAY_REFERRER = 'funxyz'

/**
 * Buffer added to Relay's time estimate (which sometimes is 0)
 */
export const RELAY_QUOTE_CHECKOUT_TIME_BUFFER_MS = 25_000 // 25 seconds

export const RELAY_TERMINAL_STATUSES: RelayExecutionStatus[] = [
  RelayExecutionStatus.REFUND,
  RelayExecutionStatus.FAILURE,
  RelayExecutionStatus.SUCCESS,
]

export const SUSHI_ORG_ID = 'fysix7gj5j'
export const HYPERSWAP_ORG_ID = '2ejzdxhfge'
